export const CommunityActivityTabs = {
  METH_TRANSACTIONS: "METH_TRANSACTIONS",
  SHOP_LOGS: "SHOP_LOGS",
  FORMULAS_LOGS: "FORMULAS_LOGS",
  LOOTBOX_SPIN: "LOOTBOX_SPIN",
  TRADING_LOGS: "TRADING_LOGS",
  TRAITS_LOGS: "TRAITS_LOGS",
  ALL: "ALL"
};
